<template>
  <!-- 新增地址页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar title="新增地址" left-arrow @click-left="toBack" />
    </div>
    <div class="center">
      <van-address-edit
        ref="address"
        show-set-default
        show-search-result
        :show-area="false"
        :show-detail="false"
        :search-result="searchResult"
        :address-info="addressinfo"
        @save="onSave"
        :value="addressinfo.areaCode"
      >
        <template #default>
          <van-field
            v-model="fieldValue"
            is-link
            readonly
            label="地区"
            placeholder="请选择所在地区"
            @click="show = true"
          />
          <van-popup v-model="show" round position="bottom">
            <van-cascader
              v-model="cascaderValue"
              title="请选择所在地区"
              :options="options"
              @change="onChange"
              @close="show = false"
              @finish="onFinish"
            />
          </van-popup>
          <van-field
            v-model="detailedAddress"
            label="详细地址"
            placeholder="街道门牌、楼层房间号等信息"
          />
        </template>
      </van-address-edit>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchResult: [],
      addressinfo: {
        areaCode: sessionStorage.getItem("Cou")
          ? sessionStorage.getItem("Cou")
          : "",
      },
      province: sessionStorage.getItem("_PROVINCE")
        ? sessionStorage.getItem("_PROVINCE")
        : "",
      city: sessionStorage.getItem("_CITY")
        ? sessionStorage.getItem("_CITY")
        : "",
      county: sessionStorage.getItem("_COUNTY")
        ? sessionStorage.getItem("_COUNTY")
        : "",
      street: sessionStorage.getItem("_STREET")
        ? sessionStorage.getItem("_STREET")
        : "",
      show: false,
      fieldValue: sessionStorage.getItem("AREA")
        ? sessionStorage.getItem("AREA")
        : "",
      cascaderValue: "",
      detailedAddress: "",
      options: [],
    };
  },
  created() {
    this.getProvince();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/address") {
        return false;
      } else if (from.path == "/onfirmOrder") {
        vm.province = sessionStorage.getItem("_PROVINCE")
          ? sessionStorage.getItem("_PROVINCE")
          : "";
        vm.city = sessionStorage.getItem("_CITY")
          ? sessionStorage.getItem("_CITY")
          : "";
        vm.county = sessionStorage.getItem("_COUNTY")
          ? sessionStorage.getItem("_COUNTY")
          : "";
        vm.street = sessionStorage.getItem("_STREET")
          ? sessionStorage.getItem("_STREET")
          : "";
      } else {
        return false;
      }
    });
  },
  methods: {
    // 保存地址的事件
    async onSave(content) {
      if (this.cascaderValue!=='') {
        await this.$post({
          url: "/omsConsigneeAddress/saveAddress",
          method: "post",
          params: {
            mobile: content.tel,
            consignee: content.name,
            province: this.province,
            city: this.city,
            district: this.county,
            street: this.street,
            address: this.detailedAddress,
            userId: sessionStorage.getItem("EXCLUSIVE"),
            firstChoice: content.isDefault == true ? 1 : 0,
          },
        })
          .then((res) => {
            if (res.retCode == 200) {
              sessionStorage.setItem("_ADDRESS", res.data.address_id);
              sessionStorage.removeItem("AREA");
              content.addressDetail = "";
              this.province = "";
              this.city = "";
              this.county = "";
              this.detailedAddress = "";
              content.name = "";
              content.tel = "";
              content.isDefault = false;
              this.$router.back();
            }
          })
          .catch((err) => {
            this.$toast("保存失败");
          });
      } else {
        this.$toast("请选择有效地址！");
      }
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      this.province = selectedOptions[0].value;
      this.city = selectedOptions[1].value;
      this.county = selectedOptions[2].value;
      sessionStorage.setItem("_PROVINCE", this.province);
      sessionStorage.setItem("_CITY", this.city);
      sessionStorage.setItem("_COUNTY", this.county);
      if (selectedOptions.length == 4) {
        this.street = selectedOptions[3].value;
        sessionStorage.setItem("_STREET", this.street);
      } else {
        this.street = "";
      }
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
    },
    // 点击获取市、区、镇级数据
    onChange({ value }) {
      this.$post({
        url: "/baseArea/listBaseArea",
        method: "get",
        params: {
          parentId: value,
        },
      }).then((res) => {
        if (res.retCode == 200) {
          if (res.data.code.length == 0) {
            return false;
          } else {
            // 市级数据
            if (res.data.code[0].level == 2) {
              this.options.forEach((element) => {
                element.children = [];
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  if (element.value == item.parent_id) {
                    element.children.push({
                      text: item.name,
                      value: item.id,
                      children: [],
                    });
                  }
                });
              });
              // 区/县级数据
            } else if (res.data.code[0].level == 3) {
              this.options.forEach((element) => {
                element.children.forEach((element2) => {
                  element2.children = [];
                });
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  element.children.forEach((element2) => {
                    if (element2.value == item.parent_id) {
                      if (item.childCount == 0) {
                        element2.children.push({
                          text: item.name,
                          value: item.id,
                        });
                      } else {
                        element2.children.push({
                          text: item.name,
                          value: item.id,
                          children: [],
                        });
                      }
                    }
                  });
                });
              });
              // 镇/街道级数据
            } else if (res.data.code[0].level == 4) {
              this.options.forEach((element) => {
                element.children.forEach((element2) => {
                  element2.children.forEach((element3) => {
                    element3.children = [];
                  });
                });
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  element.children.forEach((element2) => {
                    element2.children.forEach((element3) => {
                      element3.children.push({
                        text: item.name,
                        value: item.id,
                      });
                    });
                  });
                });
              });
            }
          }
        } else {
          this.$toast("获取地址信息失败");
        }
      });
    },
    // 获取省级数据
    getProvince() {
      this.$post({
        url: "/baseArea/listBaseArea",
        method: "get",
      }).then((res) => {
        if (res.retCode == 200) {
          res.data.code.forEach((item) => {
            return this.options.push([
              {
                text: item.name,
                value: item.id,
                children: [],
              },
            ]);
          });
          this.options = [].concat(...this.options);
        } else {
          this.$toast("获取地址信息失败");
        }
      });
    },
    toBack() {
      this.$router.back();
      sessionStorage.removeItem("AREA");
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  position: relative;
  background: rgba(245, 245, 245, 1);
  overflow: hidden;
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #f8f8f8;
    .van-nav-bar {
      background-color: #40000000;
      /deep/.van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #030303;
         font-size: 0.533333rem;
          vertical-align: middle;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
  }
  .center {
    height: 100%;
    margin: 1rem 0.27rem 0 0.27rem;
    background-color: #1f000000;
    padding-top: 0.83rem;
    .van-checkbox {
      background-color: #ffffff;
      border-radius: 0.21rem;
      margin-bottom: 0.27rem;
      /deep/.van-checkbox__icon.van-checkbox__icon--round {
        display: none;
      }
    }
  }
}
</style>
